import { j as L } from "../../_virtual/jsx-runtime.js";
const C = ({
  width: o = 20,
  height: r = 20,
  viewBox: t = "0 0 20 20",
  fill: n = "currentColor",
  ...s
}) => /* @__PURE__ */ L.jsx(
  "svg",
  {
    width: o,
    height: r,
    viewBox: t,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...s,
    children: /* @__PURE__ */ L.jsx(
      "path",
      {
        d: "M8.33333 6.01708L5.50234 8.33334H2.49999V11.6667H5.50234L8.33333 13.9829V6.01708ZM4.9074 13.3333H1.66666C1.20643 13.3333 0.833328 12.9603 0.833328 12.5V7.50001C0.833328 7.03977 1.20643 6.66668 1.66666 6.66668H4.9074L9.31949 3.0568C9.49758 2.91108 9.76008 2.93733 9.90583 3.11543C9.96674 3.18987 9.99999 3.2831 9.99999 3.37928V16.6208C9.99999 16.8508 9.81341 17.0374 9.58333 17.0374C9.48716 17.0374 9.39391 17.0042 9.31949 16.9433L4.9074 13.3333ZM17.0118 10L19.9581 12.9463L18.7796 14.1248L15.8333 11.1785L12.8871 14.1248L11.7086 12.9463L14.6548 10L11.7086 7.05373L12.8871 5.87522L15.8333 8.8215L18.7796 5.87522L19.9581 7.05373L17.0118 10Z",
        fill: n
      }
    )
  }
);
export {
  C as default
};
